import { render, staticRenderFns } from "./CardSponsorshipIcon.vue?vue&type=template&id=627967b4&scoped=true&"
import script from "./CardSponsorshipIcon.vue?vue&type=script&lang=js&"
export * from "./CardSponsorshipIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardSponsorshipIcon.vue?vue&type=style&index=0&id=627967b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627967b4",
  null
  
)

export default component.exports